import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getLocations,
  getBrandsForFilter,
  getAccountsForFilter,
  deleteLocation,
  getStates,
  showAlert,
  startHealthCheck,
} from 'actions/index';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import LocationListView from './LocationListView';

class LocationListContainer extends Component {
  componentDidMount() {
    const { fetchLocations, fetchBrands, fetchStates, fetchAccounts, location } = this.props;

    // Parse query parameters from URL
    const queryParams = location && location.search ? queryString.parse(location.search) : {};
    const { brand_id, account_id } = queryParams;
    // Fetch brands and states regardless of filters
    fetchBrands();
    fetchStates();

    // If brand_id is present, fetch accounts for that brand
    if (brand_id) {
      fetchAccounts({ brands: [brand_id] });
    }

    // Apply filters from URL to initial locations fetch
    fetchLocations({ brand_id, account_id });
  }

  render() {
    const {
      list,
      pages,
      currentPage,
      count,
      loading,
      brands,
      accounts,
      states,
      fetchLocations,
      fetchAccounts,
      removeLocation,
      role_code,
      location,
      showAlert,
      startHealthCheck,
      startHealthCheckLoading,
    } = this.props;

    // Parse query parameters to pass to LocationListView for initial state
    const queryParams = location && location.search ? queryString.parse(location.search) : {};
    const { brand_id, account_id } = queryParams;

    return (
      <LocationListView
        role_code={role_code}
        list={list}
        pages={pages}
        currentPage={currentPage}
        count={count}
        loading={loading}
        states={states}
        brands={brands}
        accounts={accounts}
        fetchLocations={fetchLocations}
        fetchAccounts={fetchAccounts}
        removeLocation={removeLocation}
        showAlert={showAlert}
        startHealthCheck={startHealthCheck}
        startHealthCheckLoading={startHealthCheckLoading}
        initialBrandId={brand_id || ''}
        initialAccountId={account_id || ''}
      />
    );
  }
}

function mapStateToProps(state) {
  const sortByLabel = (a, b) => (a.label || '').localeCompare(b.label || '');
  const sortedBrands = [
    { label: 'All Brands', value: '' },
    ...[...(state.brands.listForFilter || [])].sort(sortByLabel),
  ];
  const sortedAccounts = [
    { label: 'All Accounts', value: '' },
    ...[...(state.accounts.listForFilter || [])].sort(sortByLabel),
  ];
  const sortedStates = [
    { label: 'All States', value: '' },
    ...[...(state.utils.states || [])].sort(sortByLabel),
  ];

  return {
    role_code: state.auth.profile.role_code,
    startHealthCheckLoading: state.healthCheck.startHealthCheckLoading,
    list: state.locations.list,
    count: state.locations.count,
    loading: state.locations.loading,
    pages: state.locations.pages,
    currentPage: state.locations.currentPage,
    brands: sortedBrands,
    accounts: sortedAccounts,
    states: sortedStates,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchLocations: params => dispatch(getLocations(params)),
    fetchBrands: () => dispatch(getBrandsForFilter()),
    fetchAccounts: params => dispatch(getAccountsForFilter(params)),
    fetchStates: () => dispatch(getStates()),
    removeLocation: id => dispatch(deleteLocation(id)),
    showAlert: (message, options) => dispatch(showAlert(message, options)),
    startHealthCheck: params => dispatch(startHealthCheck(params)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationListContainer);

LocationListContainer.propTypes = {
  accounts: PropTypes.array,
  brands: PropTypes.array,
  count: PropTypes.number,
  currentPage: PropTypes.number,
  fetchAccounts: PropTypes.func,
  fetchBrands: PropTypes.func,
  fetchLocations: PropTypes.func,
  fetchStates: PropTypes.func,
  list: PropTypes.array,
  loading: PropTypes.bool,
  location: PropTypes.object,
  pages: PropTypes.number,
  removeLocation: PropTypes.func,
  role_code: PropTypes.string,
  showAlert: PropTypes.func,
  startHealthCheck: PropTypes.func,
  startHealthCheckLoading: PropTypes.bool,
  states: PropTypes.array,
};
